import Swiper from 'swiper';
import { Navigation, Pagination, Thumbs } from 'swiper/modules';
import appCore from '../core/app';

// Init app
const modAppCore = new appCore();

export default class gamesCarousel{

    listGames(elSlider: string){

        const strClass = modAppCore.rnd(10, modAppCore.rnd.alphaLower);
        let swiperInstances: any = [];

        document.querySelectorAll(elSlider)?.forEach((el: any, index: any) => {

            const el_slider = el as HTMLElement;

            el_slider.classList.add(strClass + "-" + index);

            swiperInstances[index] = new Swiper("." + strClass + "-" + index, {
                modules: [Navigation],
                slidesPerView: 1.5,
                spaceBetween: 20,
                observer: true,
                observeParents: true,
                navigation: {
                    nextEl: el_slider.getAttribute('data-next'),
                    prevEl: el_slider.getAttribute('data-prev')
                },
                breakpoints: {
                    480: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 40,
                        
                    },
                    1480: {
                        slidesPerView: 4,
                        spaceBetween: 40,
                    },
                    1920: {
                        slidesPerView: 5,
                        spaceBetween: 40,
                    }
                }
            });

        });

    }

}